import * as fromSpinner from '../reducers/spinner.reducer';
import { SpinnerActions } from '../actions/spinner.action'; // Import SpinnerActions

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ActionReducerMap } from '@ngrx/store';
import { InjectionToken } from '@angular/core';

export interface State {
  spinner: fromSpinner.SpinnerState;
}

export const SPINNER_REDUCER_TOKEN = new InjectionToken<ActionReducerMap<State, SpinnerActions>>(
  'Spinner Reducers',
); // Update InjectionToken with SpinnerActions

export function getSpinnerReducer(): ActionReducerMap<State, SpinnerActions> | any {
  // Update ActionReducerMap type
  // map of reducers
  return {
    spinner: fromSpinner.SpinnerReducer,
  };
}

const getSpinnerState = createFeatureSelector<State>('spinner-manager');

export const confirmAction = createSelector(getSpinnerState, (state) => state.spinner);

export const getSpinnerStatus = createSelector(
  getSpinnerState,
  (state) => state?.spinner?.status ?? false,
);
